import { constrainedForecastAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import { observer } from 'mobx-react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { TabPanel, TabView } from 'primereact/tabview';
import ConceptDetailsSection from 'screens/FDP/components/ConceptDetails';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import ConstrainedForecastLoadingSkeleton from './components/ConstrainedForecastSkeleton';
import NDCHeader from './components/NDCHeader';
import classes from './constraint.module.scss';
import { useConstraintForecast } from './useConstraintForecast';

const ConstraintForecast = () => {
  const {
    userModulesRoles,
    directcurrentNDCIndex,
    indirectcurrentNDCIndex,
    forecastingMonthsView,
    conceptDetails,
    contractDetails,
    isConceptLoading,
    isInvoiceSalesLoading,
    isConstrainedForecastLoading,
    directNDCheading,
    indirectNDCheading,
    isConstrainedForecastNotesDataLoading,
    constrainedForecastData,
    isConceptDetailsLoading,
    conceptSearchInput,
    constrainedForecastStatus,
    constrainedForecastPlanningPeriods,
    constrainedForecastPeriod,
    constrainedFOrecastPlanningPeriodLoading,
    isConstrainedForecastStatusLoading,
    isDirectMode,
    forecastBtnLabel,
    handleDirectNDCTabChange,
    handleIndirectNDCTabChange,
    getInvoiceSalesDetails,
    getUnconstrainedForecast,
    getConstrainedForecast,
    handleOptionChange,
    setIsDirectMode,
    ConstrainedForecastNotesData,
  } = useConstraintForecast();

  return (
    <>
      {conceptSearchInput.length <= 20 && !isConceptDetailsLoading && conceptDetails?.gfc === 0 ? (
        <div
          style={{
            width: '100vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2rem',
          }}
        >
          <h2>Search a concept to see Constrained Forecast</h2>
        </div>
      ) : (
        <div
          className={`${classes.viewContainer} ${
            conceptDetails?.gfc === 0 && !isConceptLoading && classes.displayNone
          }`}
        >
          <div className={classes.conceptContainer}>
            <h2 style={{ color: 'white' }}>Constrained Forecast</h2>
            <div>
              {isConceptLoading ? (
                <ConceptDetailsSkeleton />
              ) : (
                <ConceptDetailsSection
                  mode="view"
                  path={`edit/${conceptDetails?.gfc}`}
                  label={forecastBtnLabel}
                  loading={constrainedForecastStatus}
                  isDisabled={
                    isConstrainedForecastStatusLoading ||
                    !checkIfFunctionalityEnabled(
                      constrainedForecastAllowedRoles.createNewPlanButton,
                      userModulesRoles.fdp,
                      userModulesRoles
                    )
                  }
                  conceptDetails={conceptDetails}
                  contractDetails={contractDetails}
                />
              )}
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', padding: '.5rem' }}>
            <div className={classes.forecastCard}>
              {isConstrainedForecastLoading ? (
                <ConstrainedForecastLoadingSkeleton />
              ) : constrainedForecastPlanningPeriods.length > 0 &&
                constrainedForecastData.forecasts.length > 0 ? (
                <div>
                  <div className={classes.plan}>
                    <div>
                      <span>Choose Plan: </span>
                    </div>
                    <div className={classes.planningPeriodDropdown}>
                      <Dropdown
                        disabled={constrainedForecastPlanningPeriods.length === 0}
                        value={constrainedForecastPeriod}
                        options={constrainedForecastPlanningPeriods}
                        optionLabel="label"
                        onChange={e => {
                          handleOptionChange(e.value);
                        }}
                        style={{ width: '15rem' }}
                        loading={constrainedFOrecastPlanningPeriodLoading}
                      />
                    </div>
                  </div>

                  <div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '1rem',
                      }}
                    >
                      {directNDCheading.length > 0 && (
                        <Accordion activeIndex={0} onClick={() => setIsDirectMode(true)}>
                          <AccordionTab header="Direct">
                            <div
                              style={{
                                display: `${!isDirectMode ? 'none' : ''}`,
                              }}
                              className={classes.directtabContainer}
                            >
                              {directNDCheading.length > 0 ? (
                                <TabView
                                  scrollable
                                  tabIndex={directcurrentNDCIndex}
                                  onTabChange={handleDirectNDCTabChange}
                                >
                                  {directNDCheading.map((ndc, index) => (
                                    <TabPanel
                                      key={index}
                                      header={
                                        <NDCHeader
                                          heading={ndc.ndc}
                                          isSelected={directcurrentNDCIndex === index}
                                          tabIndex={index}
                                        />
                                      }
                                    >
                                      <div className={classes.contentContainer}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '1rem',
                                            gap: '5rem',
                                            marginTop: '1rem',
                                            marginBottom: '1rem',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <div>
                                            <p>
                                              Pack Size:{' '}
                                              <span>
                                                {directNDCheading[directcurrentNDCIndex]?.packSize}
                                              </span>
                                            </p>
                                          </div>
                                          <div className={classes.saleDetails}>
                                            <div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                  paddingLeft: '3rem',
                                                }}
                                              >
                                                YTD:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    directNDCheading[directcurrentNDCIndex].ndc,
                                                    'ytd'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                              <div className={classes.vertical}></div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                }}
                                              >
                                                3MA:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    directNDCheading[directcurrentNDCIndex].ndc,
                                                    '3ma'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                              <div className={classes.vertical}></div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                  paddingRight: '3rem',
                                                }}
                                              >
                                                PM:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    directNDCheading[directcurrentNDCIndex].ndc,
                                                    'pm'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className={classes.forecastTable}>
                                          <table>
                                            <thead>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Forecast Period
                                                </td>
                                              </th>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Unconstrained Forecast
                                                </td>
                                              </th>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Constrained Forecast
                                                </td>
                                              </th>
                                            </thead>
                                            <tbody>
                                              {forecastingMonthsView.map((_, idx) => {
                                                return (
                                                  <tr key={idx}>
                                                    <td>{forecastingMonthsView[idx].label}</td>
                                                    <td>
                                                      {getUnconstrainedForecast(
                                                        directNDCheading[directcurrentNDCIndex].ndc,
                                                        forecastingMonthsView[idx].dateString
                                                      )}
                                                    </td>
                                                    <td>
                                                      {getConstrainedForecast(
                                                        directNDCheading[directcurrentNDCIndex].ndc,
                                                        forecastingMonthsView[idx].dateString
                                                      )}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </TabPanel>
                                  ))}
                                </TabView>
                              ) : (
                                <div
                                  style={{
                                    height: '38rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                  }}
                                >
                                  No Constrained forecast data available for Direct Selling
                                  category.
                                </div>
                              )}
                            </div>
                          </AccordionTab>
                        </Accordion>
                      )}

                      {indirectNDCheading.length > 0 && (
                        <Accordion
                          onClick={() => setIsDirectMode(false)}
                          activeIndex={directNDCheading.length === 0 ? 0 : null}
                        >
                          <AccordionTab header="Indirect">
                            <div className={classes.directtabContainer}>
                              {indirectNDCheading.length > 0 ? (
                                <TabView
                                  scrollable
                                  tabIndex={indirectcurrentNDCIndex}
                                  onTabChange={handleIndirectNDCTabChange}
                                >
                                  {indirectNDCheading.map((ndc, index) => (
                                    <TabPanel
                                      key={index}
                                      header={
                                        <NDCHeader
                                          heading={ndc.ndc}
                                          isSelected={indirectcurrentNDCIndex === index}
                                          tabIndex={index}
                                        />
                                      }
                                    >
                                      <div className={classes.contentContainer}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '1rem',
                                            gap: '5rem',
                                            marginBottom: '1rem',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <div>
                                            <p>
                                              Pack Size:{' '}
                                              <span>
                                                {
                                                  indirectNDCheading[indirectcurrentNDCIndex]
                                                    ?.packSize
                                                }
                                              </span>
                                            </p>
                                          </div>
                                          <div className={classes.saleDetails}>
                                            <div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                  paddingLeft: '3rem',
                                                }}
                                              >
                                                YTD:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                    'ytd'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                              <div className={classes.vertical}></div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                }}
                                              >
                                                3MA:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                    '3ma'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                              <div className={classes.vertical}></div>
                                              <div
                                                style={{
                                                  fontSize: '14px',
                                                  fontWeight: '600',
                                                  paddingRight: '3rem',
                                                }}
                                              >
                                                PM:{' '}
                                                {!isInvoiceSalesLoading ? (
                                                  getInvoiceSalesDetails(
                                                    indirectNDCheading[indirectcurrentNDCIndex].ndc,
                                                    'pm'
                                                  )
                                                ) : (
                                                  <ProgressSpinner
                                                    style={{
                                                      width: '10px',
                                                      height: '10px',
                                                      padding: 0,
                                                      margin: 0,
                                                    }}
                                                    strokeWidth="8"
                                                    fill="var(--surface-ground)"
                                                    animationDuration="1s"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className={classes.forecastTable}>
                                          <table>
                                            <thead>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Forecast Period
                                                </td>
                                              </th>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Unconstrained Forecast
                                                </td>
                                              </th>
                                              <th>
                                                <td style={{ fontSize: '15px' }}>
                                                  Constrained Forecast
                                                </td>
                                              </th>
                                            </thead>
                                            <tbody>
                                              {forecastingMonthsView.map((_, idx) => {
                                                return (
                                                  <tr key={idx}>
                                                    <td>{forecastingMonthsView[idx].label}</td>
                                                    <td>
                                                      {getUnconstrainedForecast(
                                                        indirectNDCheading[indirectcurrentNDCIndex]
                                                          .ndc,
                                                        forecastingMonthsView[idx].dateString
                                                      )}
                                                    </td>
                                                    <td>
                                                      {getConstrainedForecast(
                                                        indirectNDCheading[indirectcurrentNDCIndex]
                                                          .ndc,
                                                        forecastingMonthsView[idx].dateString
                                                      )}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </TabPanel>
                                  ))}
                                </TabView>
                              ) : (
                                <div
                                  style={{
                                    height: '38rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                  }}
                                >
                                  No Constrained forecast data available for Indirect Selling
                                  category.
                                </div>
                              )}
                            </div>
                          </AccordionTab>
                        </Accordion>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '2rem',
                  }}
                >
                  No Constrained Forecast data found!!
                </div>
              )}
            </div>
            <NotesSection
              mode="view"
              isNotesDataLoading={
                isConstrainedForecastNotesDataLoading ||
                isConstrainedForecastLoading ||
                isConceptLoading
              }
              notesData={ConstrainedForecastNotesData}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default observer(ConstraintForecast);
